(function ($) {
	class W4D_Accordion {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.accordionGroups = $('.accordion-group');
		}

		/**
		 * Checks if the accordion should be static (non-interactive) based on current viewport and classes.
		 * @param {jQuery} $el The <details> element
		 * @returns {boolean}
		 */
		isStatic($el) {
			const isDesktop = window.innerWidth >= 1200; // lg breakpoint
			const isTabMob = window.innerWidth < 1200;

			if (isDesktop && $el.hasClass('accordion--static-desktop')) return true;
			if (isTabMob && $el.hasClass('accordion--static-tab-mob')) return true;

			// NEW: Ignore accordion behavior if it's a filter that isn't in mobile mode
			if ($el.hasClass('filter')) {
				// filter--aside should always be interactive accordions
				if ($el.hasClass('filter--aside')) return false;

				if (!$el.closest('.filters--mobile').length) return true;
				// If it is mobile, it's NOT static even if it has accordion--static class
				return false;
			}

			if ($el.hasClass('accordion--static')) return true;

			return false;
		}

		bindEvents() {
			this.accordionGroups.on('keydown', 'summary', (e) => {
				if (this.isStatic($(e.currentTarget).closest('details'))) return;
				this.handleKeydown(e);
			});

			// Toggle event doesn't bubble, so we must use capture phase on the group or bind directly
			this.accordionGroups.each((i, group) => {
				group.addEventListener(
					'toggle',
					(e) => {
						if (e.target.tagName.toLowerCase() === 'details') {
							const $details = $(e.target);
							if (this.isStatic($details)) {
								// Ensure static accordions remain open
								if (!$details.prop('open')) {
									$details.prop('open', true);
								}
								return;
							}
							this.handleToggle(e);
						}
					},
					true
				);
			});
		}

		handleToggle(e) {
			const $details = $(e.target);
			if (!$details.prop('open')) return;

			// Use requestAnimationFrame but rely on scrollHeight for the final height calculation
			requestAnimationFrame(() => {
				this.scrollToFit($details);
			});
		}

		scrollToFit($el) {
			const el = $el[0];
			const scrollTop = $(window).scrollTop();
			const viewportHeight = window.innerHeight;
			const offset = 20;

			// Get the element's top position relative to the document
			const elementTop = $el.offset().top;

			// Calculate height more reliably by summing summary and content scrollHeight.
			// In some browser implementations, el.scrollHeight on <details> may not include the summary.
			const $summary = $el.find('> summary');
			const $content = $el.find('> .accordion__content');

			const summaryHeight = $summary.outerHeight() || 0;
			const contentHeight = $content.length ? $content[0].scrollHeight : 0;

			// Total height = summary + content (we use Math.max for robustness against browser behaviors)
			const elementFullHeight = Math.max(el.scrollHeight, summaryHeight + contentHeight);
			const elementBottom = elementTop + elementFullHeight;

			let targetScrollTop = null;

			if (elementTop < scrollTop + offset) {
				// if the top of the summary is the above viewport, scroll UP
				targetScrollTop = elementTop - offset;
			} else if (elementBottom > scrollTop + viewportHeight - offset) {
				// if an element is below the viewport, scroll DOWN
				targetScrollTop = elementBottom - (viewportHeight - offset);

				// if scrolling to the bottom pushes the top off-screen, cap it so the top remains visible
				targetScrollTop = Math.min(targetScrollTop, elementTop - offset);
			}

			// Only animate if there's a significant scroll required
			if (targetScrollTop !== null && Math.abs(targetScrollTop - scrollTop) > 1) {
				const $body = $('html, body');

				// Ensure targetScrollTop is not negative
				targetScrollTop = Math.max(0, targetScrollTop);

				// Interrupt scroll on wheel, touchstart (and mousemove with a delay)
				let isAnimating = true;
				const interruptScroll = () => {
					if (!isAnimating) return;
					$body.stop();
					cleanupInterrupts();
				};

				const cleanupInterrupts = () => {
					isAnimating = false;
					$(window).off('wheel touchstart mousemove', interruptScroll);
				};

				$(window).on('wheel touchstart', interruptScroll);

				// Delay mousemove interrupt to prevent it from firing due to the initial click/movement
				setTimeout(() => {
					if (isAnimating) {
						$(window).on('mousemove', interruptScroll);
					}
				}, 100);

				if (!$.easing.cubicBezier) {
					$.easing.cubicBezier = (x) => {
						return x * x * (3 - 2 * x);
					};
				}

				$body.animate(
					{ scrollTop: targetScrollTop },
					{
						duration: 400,
						easing: 'cubicBezier',
						complete: cleanupInterrupts,
					}
				);
			}
		}

		handleKeydown(e) {
			const key = e.key;
			const $summary = $(e.currentTarget);
			const $group = $summary.closest('.accordion-group');
			const $summaries = $group.find('summary');
			const index = $summaries.index($summary);

			let targetIndex;

			switch (key) {
				case 'ArrowDown':
					e.preventDefault();
					targetIndex = (index + 1) % $summaries.length;
					$summaries.eq(targetIndex).focus();
					break;
				case 'ArrowUp':
					e.preventDefault();
					targetIndex = (index - 1 + $summaries.length) % $summaries.length;
					$summaries.eq(targetIndex).focus();
					break;
				case 'ArrowLeft':
					e.preventDefault();
					$summary.closest('details').prop('open', false);
					break;
				case 'ArrowRight':
					e.preventDefault();
					$summary.closest('details').prop('open', true);
					break;
				case 'Home':
					e.preventDefault();
					$summaries.first().focus();
					break;
				case 'End':
					e.preventDefault();
					$summaries.last().focus();
					break;
				default:
					return;
			}
		}
	}

	$(document).ready(() => {
		new W4D_Accordion();
	});
})(jQuery);
